import React, { useEffect, useState } from 'react';
import "./PrintTripSheet.css"
// import "../../Tripsheet/PrintTripsheet.css"
import apf_logo from '../../../../images/auth/apf_logo_full.png';
import { Col } from "react-bootstrap";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react'; 

const PrintTripsheet = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const branch_id = parseInt(params.get("branch_id"));
    const schedule_id = parseInt(params.get("schedule_id"));
    const date = params.get("date");
    const product_id = parseInt(params.get("product_id"));
    const delivery_point = parseInt(params.get("delivery_point"));
    const deliveryPointsParam = params.get("delivery_point"); // e.g., "2,5,7"
    const deliveryPointsArray = deliveryPointsParam ? deliveryPointsParam.split(',') : [];

    console.log(branch_id, schedule_id, date, product_id, delivery_point);

    const [product_name, setProduct] = useState([]);
    const [dp_name, setdp] = useState([]);
    const [delivery_details, setDeliverydetail] = useState([]);
    const [dispdate, setDate] = useState(null);
    const [prod_count, setcount] = useState(0);
    const [datas, setData] = useState([]);
    const [isHoliday, setIsHoliday] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);
    // page table data fetch
    const fetchData = () => {
        const params = {
            // search: searchTerm,
            // product_id: product_id,
            branch: branch_id,
            dp: deliveryPointsParam,
            date: date,
            schedule_id: schedule_id,
        };
        axios.get(`${baseURL}/delivery/print`, { params: params })
            .then(response => {
                setProduct(response.data.productName);
                setdp(response.data.delivery_point_name);
                setDeliverydetail(response.data.subscribers);
                setDate(response.data.date);
                setcount(response.data.product_count);
                setHasFetched(true);
                if(response.data.is_holiday === 1){
                    setIsHoliday(true);
                } else {
                    setIsHoliday(false);
                }
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    useEffect (() => {
        if(schedule_id){
            fetchData();
        }
    }, [schedule_id]);

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        if(hasFetched){
            window.print();
        }
    }, [hasFetched]);

    return (
        <div>
            <div className='page_print'>
                {/* <content> */}
                <div className='fs-3 text-black text-center'>
                    <label>Trip Sheet Report</label>
                </div>
                <div className="row mt-2">
                    <div className="col-lg-12 mb-3 d-flex align-items-center justify-content-between mb-3">
                        <div>
                            <label className="justify-content-start p-0 ms-1">
                                <img src={apf_logo} alt="Logo" className="w-250px h-50px ms-0" />
                            </label>
                        </div>
                        <div>
                            <div>
                                <div className='text-black fs-6'>
                                    <span><i className="fa-regular fa-calendar me-3"></i></span>
                                    <span>{formatDate(date)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='border-bottom'></div>
                    <div className='col-lg-12 mt-3'>
                        <Col xl={12} className=''>
                            <label className="text-black fw-semibold fs-4">Meals Point</label>
                        </Col>
                        <Col xl={12} className='mb-3'>
                            <div className="">
                                <label className='text-black me-2'>{dp_name.join(', ')}</label>
                            </div>
                        </Col>
                    </div>
                    <div className="col-lg-12 mb-2">
                        <table className="table align-middle table-striped fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                            <thead>
                                <tr className="text-start fw-bold fs-6 gs-0 bg-primary">
                                    <th className='min-w-50px text-start text-white'>S.No</th>
                                    <th className='min-w-100px text-white'>Customer</th>
                                    <th className='min-w-100px text-white'>Contact</th>
                                    <th className='min-w-100px text-white'>Product</th>
                                    <th className='min-w-100px text-white'>Area</th>
                                    <th className='min-w-100px text-white'>Address</th>
                                    <th className='min-w-50px text-white'>Count</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {delivery_details.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" className="text-center text-muted py-2">
                                            No data available
                                        </td>
                                    </tr>
                                ) : (
                                    <>
                                        {delivery_details.map((data, index) => (
                                            <tr>
                                                <td className='text-start'>
                                                    <label className='text-black font-w400 fs-7'>{index + 1}</label>
                                                </td>
                                                <td>
                                                    <label className='text-black font-w400 fs-7'>{data.person_name}</label>
                                                </td>
                                                <td>
                                                    <label className='text-black font-w400 fs-7'>{data.person_contact}</label>
                                                </td>
                                                <td>
                                                    <label className='text-black font-w400 fs-7'>{data.product_name}</label>
                                                </td>
                                                <td>
                                                    <label className='text-black font-w400 fs-7'>{data.area_name}</label>
                                                </td>
                                                <td>
                                                    <div className='text-black font-w400 fs-7 mw-300px text-wrap'>{data.address}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <label className='text-black fs-7 '>{data.product_count.toString().padStart(2, '0')}</label>
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className='col-lg-12 d-flex align-items-center justify-content-end'>
                        <div className="text-black fw-bold fs-4">
                        <label>Total Count</label>
                        <label className="me-1 ms-1">-</label>
                        <label>{prod_count.toString().padStart(2, '0')}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )


}
export default PrintTripsheet;